import { REDUX_REQUEST_TYPES } from 'app/types/store.types'

export const createRequestTypes = (base: string) =>
  Object.values(REDUX_REQUEST_TYPES).reduce(
    (acc, type) => {
      acc[type] = `${base}_${type}`
      return acc
    },
    {} as Record<REDUX_REQUEST_TYPES, string>
  )

export const action = <PayloadType extends Record<string, unknown> = {}>(
  type: string,
  payload: PayloadType
) => ({ type, ...payload })

export const createActions = (requestTypes: Record<string, string>) => ({
  request: <T extends unknown = unknown>(payload?: T) =>
    action(requestTypes[REDUX_REQUEST_TYPES.REQUEST], { payload }),
  success: <T extends unknown = unknown>(payload: T) =>
    action(requestTypes[REDUX_REQUEST_TYPES.SUCCESS], { payload }),
  failure: <T extends unknown = unknown>(error: T) =>
    action(requestTypes[REDUX_REQUEST_TYPES.FAILURE], { payload: error }),
})
